export default {
  list: {
    pageTitle: '流程管理',
    totalRecords: '共 {count} 条',
    search: {
      name: '流程名称',
      office: '适用分公司',
      form: '绑定表单',
      status: '运行状态',
      createdAt: '创建时间',
      namePlaceholder: '请输入流程名称',
      officePlaceholder: '请选择分公司',
      formPlaceholder: '请选择绑定表单',
      statusPlaceholder: '请选择运行状态',
      createdAtPlaceholder: '请选择创建时间'
    },
    table: {
      index: '序号',
      name: '流程名称',
      form: '绑定表单',
      office: '适用分公司',
      status: '运行状态',
      remark: '备注',
      creator: '创建人',
      modifier: '修改人',
      createdAt: '创建时间',
      updatedAt: '更新时间',
      operations: '操作',
      noOffice: '全部',
      unknownForm: '场景 {id}'
    },
    actions: {
      create: '新建流程',
      delegation: '委派配置',
      edit: '编辑',
      copy: '复制',
      delete: '删除',
      enable: '启用',
      disable: '停用'
    },
    confirm: {
      enable: '确认启用当前流程吗？',
      disable: '确认停用当前流程吗？',
      delete: '确认删除当前流程吗？'
    },
    messages: {
      copied: '流程复制成功',
      deleted: '流程删除成功',
      enabled: '流程启用成功',
      disabled: '流程停用成功',
      loaded: '流程数据加载成功'
    }
  },
  delegation: {
    title: '委派配置',
    table: {
      index: '序号',
      approver: '审批人',
      delegatee: '委派人',
      operations: '操作'
    },
    placeholders: {
      approver: '请选择审批人',
      delegatee: '请选择委派人'
    },
    actions: {
      addRow: '新增一行'
    },
    messages: {
      approverRequired: '请选择审批人',
      delegateeRequired: '请选择委派人',
      duplicateApprover: '审批人不能重复',
      crossDuplicate: '审批人与委派人不能重复交叉配置',
      saved: '委派配置已保存'
    }
  },
  editor: {
    createTitle: '新建流程',
    editTitle: '编辑流程',
    canvasTitle: '流程设计',
    basicInfo: '基本信息',
    nodeSettings: '节点设置',
    branchLimit: '最大分支数：{count}',
    selectedNode: '当前节点：{name}',
    noNodeSelected: '请选择右侧流程节点后再配置',
    noRuleDefinition: '当前绑定表单暂无可用条件字段',
    form: {
      name: '流程名称',
      office: '适用分公司',
      form: '绑定表单',
      canUndo: '允许撤回',
      unknownProcessHandleMode: '未知流程处理',
      quickApprovalMode: '不同节点相同审批人处理方式',
      needConfirmPopupOnInitiate: '发起时是否需要再次确认',
      autoWriteOffAfterApproval: '审批通过后是否自动核销',
      invoicingMode: '开票模式',
      templatePush: '模板推送',
      notifications: '消息通知方式',
      remark: '备注',
      namePlaceholder: '请输入流程名称',
      officePlaceholder: '请选择分公司',
      formPlaceholder: '请选择绑定表单',
      remarkPlaceholder: '请输入备注',
      branchLimitPlaceholder: '选择分公司和表单后自动计算',
      autoWriteOffHelp: '兼容老系统字段，当前按后端能力传值',
      templatePlaceholder: '请选择模板',
      exportTypePlaceholder: '请选择导出方式'
    },
    tabs: {
      process: '流程',
      node: '节点'
    },
    enums: {
      canUndo: {
        allowed: '允许撤销',
        notAllowed: '不可撤销'
      },
      autoWriteOff: {
        none: '不核销',
        original: '自动核销'
      },
      formSubtype: {
        makeInvoiceBilling: '账单申请',
        makeInvoiceInternalInvoice: '内部发票申请',
        collectInvoiceInternalInvoice: '内部发票申请'
      },
      businessScene: {
        billPayment: '付款申请单',
        makeInvoice: '开票申请单',
        jobCharge: '业务费用申请单',
        tempCredit: '临时信控申请单',
        chargeChange: '费用更改申请单',
        collectInvoice: '收票申请单',
        partnerApplicationForm: '合作伙伴申请单',
        contractApplicationForm: '合同申请单',
        advPaymentRefundForm: '预付款退款申请单'
      },
      status: {
        enabled: '启用',
        disabled: '停用',
        hiddenDisabled: '隐藏停用'
      },
      branchRuleMode: {
        none: '无条件',
        any: '任一满足',
        all: '全部满足'
      },
      nodeType: {
        single: '或签',
        all: '会签'
      },
      actorType: {
        role: '角色',
        user: '用户',
        parent: '上级主管',
        position: '岗位'
      },
      unknownProcessHandleMode: {
        pass: '未匹配到直接进行下一步操作',
        reject: '未匹配到进行异常提示'
      },
      quickApprovalMode: {
        firstNode: '首节点处理后，其余均自动同意',
        continuousNode: '仅连续处理时自动同意',
        everyNode: '每个节点任务都需处理'
      },
      notifications: {
        email: '邮件',
        bell: '铃铛',
        weixin: '微信',
        enterpriseWechat: '钉钉'
      },
      cancelAllowed: {
        previous: '退回上一节点',
        initiator: '退回发起节点'
      },
      relation: {
        and: '且',
        or: '或'
      }
    },
    branch: {
      main: '主流程',
      branch: '分支 {index}',
      addBranch: '新增分支',
      addNode: '新增节点',
      deleteBranch: '删除分支',
      ruleSummary: '触发条件',
      noRule: '无条件',
      allRule: '全部满足',
      anyRule: '任一满足',
      deleteConfirm: '确认删除该分支吗？'
    },
    node: {
      unnamed: '未命名节点',
      name: '节点名称',
      type: '审批方式',
      actorType: '审批人类型',
      actorId: '审批人',
      notifierType: '通知人类型',
      notifierId: '通知人',
      editable: '允许编辑单据',
      remarkRequired: '审批备注必填',
      cancelAllowed: '驳回方式',
      transferAllowed: '允许转交',
      dashboardName: '仪表盘名称',
      dashboardId: '仪表盘ID',
      preCriteria: '前置条件',
      namePlaceholder: '请输入节点名称',
      actorPlaceholder: '请选择审批人',
      notifierPlaceholder: '请选择通知人',
      positionPlaceholder: '请输入岗位ID',
      dashboardNamePlaceholder: '请输入仪表盘名称',
      dashboardIdPlaceholder: '请输入仪表盘ID',
      parentHint: '上级主管按发起人组织关系自动解析，保存时会使用系统占位值。',
      positionHint: '当前系统尚未接入岗位下拉，先按岗位ID配置。'
    },
    condition: {
      title: '条件配置',
      branchTitle: '分支触发条件',
      preTitle: '节点前置条件',
      relation: '关系',
      field: '条件字段',
      operator: '运算符',
      value: '条件值',
      sequence: '序号',
      operation: '操作',
      add: '新增条件',
      delete: '删除条件',
      deleteSelected: '删除',
      empty: '暂无条件',
      valuePlaceholder: '请输入条件值',
      fieldPlaceholder: '请选择字段',
      operatorPlaceholder: '请选择运算符',
      valueSelectPlaceholder: '请选择条件值'
    },
    actions: {
      save: '保存',
      cancel: '取消',
      backToList: '返回列表'
    },
    messages: {
      loaded: '流程详情加载成功',
      saved: '流程保存成功',
      rulesLoaded: '条件字段加载成功',
      branchLimitLoaded: '分支上限已更新',
      formRequired: '请先选择绑定表单',
      formSubtypeRequired: '请选择开票模式',
      exportTypeRequired: '请选择模板导出方式',
      officeRequired: '请先选择分公司',
      nameRequired: '请输入流程名称',
      branchRequired: '至少保留一个流程分支',
      nodeRequired: '每个分支至少保留一个审批节点',
      nodeNameRequired: '请填写节点名称',
      actorTypeRequired: '请选择审批人类型',
      actorRequired: '请补全审批人配置',
      notifierRequired: '请补全通知人配置',
      ruleRequired: '请补全分支触发条件',
      duplicateRule: '存在重复的分支触发条件',
      preCriteriaRequired: '请补全节点前置条件',
      branchLimitExceeded: '当前分支数量已达到上限 {count}',
      deleteNodeConfirm: '确认删除当前节点吗？',
      formOptionsLoading: '正在加载可用表单',
      branchLimitUnavailable: '当前未获取到分支上限，请联系后端确认平台配置'
    }
  }
}
